import { render, staticRenderFns } from "./file-upload-base64.vue?vue&type=template&id=738eeef4&scoped=true"
import script from "./file-upload-base64.vue?vue&type=script&lang=js"
export * from "./file-upload-base64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738eeef4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
